import { IDemoFormInputs, IInformFormInputs } from "../models/demoForm";

export const createContent = (data: IDemoFormInputs, type: string): string => {
  return [
    type,
    `Name: ${data.firstName} ${data.lastName}`,
    `Company: ${data.company}`,
    `Email: ${data.email}`,
    `Phone Number: ${data.phoneNumber}`,
    `Interested in: ${data.interested}`,
    `Message: ${data.needHelp}`,
  ].join(" \n");
};

export const createReportContent = (data: IInformFormInputs): string => {
  return [
    "Report a Broken link",
    `Name: ${data.firstName} ${data.lastName}`,
    `Broken Url: ${data.brokenUrl}`,
    `Description: ${data.description}`,
  ].join(" \n");
};
